import { cva as e, cx as t } from "class-variance-authority";
import { Fragment as n, jsx as r, jsxs as i } from "react/jsx-runtime";
import { createContext as a, useCallback as o, useContext as s, useEffect as c, useRef as l, useState as u } from "react";
var d = e("brut-btn", {
	variants: {
		variant: {
			default: "",
			primary: "brut-btn-primary",
			danger: "brut-btn-danger",
			success: "brut-btn-success"
		},
		icon: {
			true: "brut-btn-icon",
			false: ""
		}
	},
	defaultVariants: {
		variant: "default",
		icon: !1
	}
});
function f({ variant: e, icon: n, className: i, ...a }) {
	return /* @__PURE__ */ r("button", {
		className: t(d({
			variant: e,
			icon: n
		}), i),
		...a
	});
}
var p = e("", {
	variants: { sub: {
		true: "brut-card-sub",
		false: "brut-card"
	} },
	defaultVariants: { sub: !1 }
});
function m({ sub: e, className: n, ...i }) {
	return /* @__PURE__ */ r("div", {
		className: t(p({ sub: e }), n),
		...i
	});
}
//#endregion
//#region src/Input.tsx
function h({ className: e, ...n }) {
	return /* @__PURE__ */ r("input", {
		className: t("brut-input", e),
		...n
	});
}
function g({ className: e, ...n }) {
	return /* @__PURE__ */ r("select", {
		className: t("brut-select", e),
		...n
	});
}
//#endregion
//#region src/Kbd.tsx
function _({ className: e, ...n }) {
	return /* @__PURE__ */ r("kbd", {
		className: t("brut-kbd", e),
		...n
	});
}
//#endregion
//#region src/Badge.tsx
function v({ className: e, ...n }) {
	return /* @__PURE__ */ r("span", {
		className: t("brut-badge", e),
		...n
	});
}
//#endregion
//#region src/Menu.tsx
function y({ className: e, ...n }) {
	return /* @__PURE__ */ r("div", {
		className: t("brut-menu", e),
		...n
	});
}
function b({ danger: e, className: n, ...i }) {
	return /* @__PURE__ */ r("button", {
		className: t("brut-menu-item", e && "brut-menu-item-danger", n),
		...i
	});
}
//#endregion
//#region src/Dialog.tsx
var x = [
	"a[href]",
	"button:not([disabled])",
	"input:not([disabled])",
	"select:not([disabled])",
	"textarea:not([disabled])",
	"[tabindex]:not([tabindex=\"-1\"])"
].map((e) => `${e}:not([hidden]):not([aria-hidden="true"])`).join(",");
function S(e) {
	return Array.from(e.querySelectorAll(x));
}
var C = e("brut-dialog", {
	variants: { size: {
		sm: "",
		md: "brut-dialog-md",
		lg: "brut-dialog-lg"
	} },
	defaultVariants: { size: "sm" }
});
function w({ isOpen: e, onClose: n, initialFocusRef: i, size: a, className: o, labelledBy: s, children: u }) {
	let d = l(null), f = l(null);
	return c(() => {
		if (!e) return;
		let t = document.activeElement;
		if (i?.current) i.current.focus();
		else {
			let e = d.current;
			((e ? S(e)[0] : void 0) ?? f.current)?.focus();
		}
		return () => t?.focus?.();
	}, [e, i]), c(() => {
		if (!e) return;
		let t = (e) => {
			if (e.key === "Escape") {
				n();
				return;
			}
			if (e.key !== "Tab") return;
			let t = d.current;
			if (!t) return;
			let r = S(t), i = r[0], a = r[r.length - 1];
			if (!i || !a) return;
			let o = document.activeElement;
			e.shiftKey ? (o === i || !t.contains(o)) && (e.preventDefault(), a.focus()) : (o === a || !t.contains(o)) && (e.preventDefault(), i.focus());
		};
		return document.addEventListener("keydown", t), () => document.removeEventListener("keydown", t);
	}, [e, n]), c(() => {
		if (e) return document.body.classList.add("brut-scroll-lock"), () => document.body.classList.remove("brut-scroll-lock");
	}, [e]), e ? /* @__PURE__ */ r("div", {
		ref: d,
		className: "brut-dialog-backdrop",
		onClick: n,
		children: /* @__PURE__ */ r(m, {
			ref: f,
			tabIndex: -1,
			role: "dialog",
			"aria-modal": "true",
			"aria-labelledby": s,
			className: t(C({ size: a }), o),
			onClick: (e) => e.stopPropagation(),
			children: u
		})
	}) : null;
}
//#endregion
//#region src/ConfirmDialog.tsx
function T({ isOpen: e, title: t, message: n, confirmLabel: a = "Confirm", cancelLabel: o = "Cancel", variant: s = "default", onConfirm: c, onCancel: u }) {
	let d = l(null);
	return /* @__PURE__ */ i(w, {
		isOpen: e,
		onClose: u,
		initialFocusRef: d,
		children: [
			/* @__PURE__ */ r("h3", {
				className: "brut-dialog-title",
				children: t
			}),
			/* @__PURE__ */ r("p", {
				className: "brut-dialog-message",
				children: n
			}),
			/* @__PURE__ */ i("div", {
				className: "brut-dialog-actions",
				children: [/* @__PURE__ */ r(f, {
					onClick: u,
					children: o
				}), /* @__PURE__ */ r(f, {
					ref: d,
					onClick: c,
					variant: s === "danger" ? "danger" : "primary",
					children: a
				})]
			})
		]
	});
}
//#endregion
//#region src/Toast.tsx
var E = a(null), D = () => {
	let e = s(E);
	if (!e) throw Error("useToast must be used within a ToastProvider");
	return e;
}, O = {
	success: "brut-toast-success",
	error: "brut-toast-error",
	warning: "brut-toast-warning",
	info: "brut-toast-info"
};
function k({ toast: e, onDismiss: n }) {
	let a = l(null);
	return c(() => (a.current = window.setTimeout(() => {
		n(e.id);
	}, e.duration), () => {
		a.current && clearTimeout(a.current);
	}), [
		e.id,
		e.duration,
		n
	]), /* @__PURE__ */ i("div", {
		className: t("brut-toast", O[e.type]),
		children: [
			/* @__PURE__ */ r("span", {
				className: "brut-toast-message",
				children: e.message
			}),
			e.action && /* @__PURE__ */ r("button", {
				type: "button",
				onClick: () => {
					e.action.onClick(), n(e.id);
				},
				className: "brut-toast-action",
				children: e.action.label
			}),
			/* @__PURE__ */ r("button", {
				type: "button",
				onClick: () => n(e.id),
				className: "brut-toast-dismiss",
				"aria-label": "Dismiss",
				children: /* @__PURE__ */ r("svg", {
					width: "16",
					height: "16",
					viewBox: "0 0 24 24",
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "3",
					children: /* @__PURE__ */ r("path", {
						d: "M18 6L6 18M6 6l12 12",
						strokeLinecap: "round"
					})
				})
			})
		]
	});
}
function A({ children: e }) {
	let [t, n] = u([]), a = o((e, t, r) => {
		let i = `toast_${Date.now()}_${Math.random()}`, a = r?.action ? 6e3 : 4e3, o = r?.duration ?? a;
		n((n) => [...n, {
			id: i,
			message: e,
			type: t,
			duration: o,
			action: r?.action
		}]);
	}, []), s = o((e) => {
		n((t) => t.filter((t) => t.id !== e));
	}, []);
	return /* @__PURE__ */ i(E.Provider, {
		value: { addToast: a },
		children: [e, t.length > 0 && /* @__PURE__ */ r("div", {
			className: "brut-toast-viewport",
			role: "status",
			"aria-live": "polite",
			children: t.map((e) => /* @__PURE__ */ r(k, {
				toast: e,
				onDismiss: s
			}, e.id))
		})]
	});
}
var j = e("brut-alert", {
	variants: { variant: {
		info: "brut-alert-info",
		warning: "brut-alert-warning",
		danger: "brut-alert-danger",
		success: "brut-alert-success",
		throttle: "brut-alert-throttle",
		failure: "brut-alert-failure",
		down: "brut-alert-down"
	} },
	defaultVariants: { variant: "info" }
}), M = {
	info: "status",
	success: "status",
	warning: "alert",
	danger: "alert",
	throttle: "status",
	failure: "alert",
	down: "status"
};
function N({ variant: e, title: n, className: a, children: o, ...s }) {
	return /* @__PURE__ */ i("div", {
		role: M[e ?? "info"],
		className: t(j({ variant: e }), a),
		...s,
		children: [n ? /* @__PURE__ */ r("p", {
			className: "brut-alert-title",
			children: n
		}) : null, /* @__PURE__ */ r("div", {
			className: "brut-alert-body",
			children: o
		})]
	});
}
//#endregion
//#region src/FormField.tsx
function P({ label: e, htmlFor: n, error: a, success: o, hint: s, className: c, children: l }) {
	return /* @__PURE__ */ i("div", {
		className: t("brut-field", c),
		children: [
			/* @__PURE__ */ r("label", {
				className: "brut-field-label",
				htmlFor: n,
				children: e
			}),
			l,
			a ? /* @__PURE__ */ r("p", {
				className: "brut-field-error",
				children: a
			}) : null,
			o ? /* @__PURE__ */ r("p", {
				className: "brut-field-success",
				children: o
			}) : null,
			s ? /* @__PURE__ */ r("p", {
				className: "brut-field-hint",
				children: s
			}) : null
		]
	});
}
//#endregion
//#region src/SegmentedControl.tsx
function F({ options: e, value: n, onChange: i, ariaLabel: a, className: o }) {
	return /* @__PURE__ */ r("div", {
		role: "group",
		"aria-label": a,
		className: t("brut-segmented", o),
		children: e.map((e) => {
			let t = e.value === n;
			return /* @__PURE__ */ r(f, {
				type: "button",
				variant: t ? "primary" : "default",
				"aria-pressed": t,
				onClick: () => i(e.value),
				children: e.label
			}, String(e.value));
		})
	});
}
//#endregion
//#region src/Panel.tsx
function I({ title: e, action: n, className: a, children: o, ...s }) {
	let c = e != null || n != null;
	return /* @__PURE__ */ i(m, {
		className: t("brut-panel", a),
		...s,
		children: [c ? /* @__PURE__ */ i("div", {
			className: "brut-panel-header",
			children: [e == null ? /* @__PURE__ */ r("span", {}) : /* @__PURE__ */ r("h2", {
				className: "brut-panel-title",
				children: e
			}), n]
		}) : null, o]
	});
}
//#endregion
//#region src/EmptyState.tsx
function L({ className: e, children: n, ...i }) {
	return /* @__PURE__ */ r(m, {
		sub: !0,
		className: t("brut-empty", e),
		...i,
		children: n
	});
}
//#endregion
//#region src/Ping.tsx
function R({ className: e, ...n }) {
	return /* @__PURE__ */ r("span", {
		"aria-hidden": !0,
		className: t("brut-ping", e),
		...n
	});
}
//#endregion
//#region src/StatRow.tsx
function z(e) {
	let { leading: t, leadingClassName: n, label: r, labelClassName: i, value: a, valueClassName: o, trailing: s, trailingClassName: c, ...l } = e;
	return {
		slots: {
			leading: t,
			leadingClassName: n,
			label: r,
			labelClassName: i,
			value: a,
			valueClassName: o,
			trailing: s,
			trailingClassName: c
		},
		rest: l
	};
}
function B({ leading: e, leadingClassName: a, label: o, labelClassName: s, value: c, valueClassName: l, trailing: u, trailingClassName: d }) {
	return /* @__PURE__ */ i(n, { children: [
		e == null ? null : /* @__PURE__ */ r("span", {
			className: t("brut-statrow-leading", a),
			children: e
		}),
		/* @__PURE__ */ r("span", {
			className: t("brut-statrow-label", s),
			children: o
		}),
		/* @__PURE__ */ r("span", {
			className: t("brut-statrow-value", l),
			children: c
		}),
		u == null ? null : /* @__PURE__ */ r("span", {
			className: t("brut-statrow-trailing", d),
			children: u
		})
	] });
}
function V(e) {
	if (e.as === "li") {
		let { slots: n, rest: i } = z(e), { as: a, className: o, ...s } = i;
		return /* @__PURE__ */ r("li", {
			className: t("brut-statrow", o),
			...s,
			children: /* @__PURE__ */ r(B, { ...n })
		});
	}
	let { slots: n, rest: i } = z(e), { as: a, className: o, ...s } = i;
	return /* @__PURE__ */ r("div", {
		className: t("brut-statrow", o),
		...s,
		children: /* @__PURE__ */ r(B, { ...n })
	});
}
//#endregion
//#region src/Tabs.tsx
function H({ options: e, value: n, onChange: i, ariaLabel: a, controls: o, className: s }) {
	let c = l([]), u = (t) => {
		let n = e[t];
		n && (i(n.value), c.current[t]?.focus());
	}, d = (t, n) => {
		let r = e.length - 1;
		switch (t.key) {
			case "ArrowRight":
			case "ArrowDown":
				t.preventDefault(), u(n === r ? 0 : n + 1);
				break;
			case "ArrowLeft":
			case "ArrowUp":
				t.preventDefault(), u(n === 0 ? r : n - 1);
				break;
			case "Home":
				t.preventDefault(), u(0);
				break;
			case "End":
				t.preventDefault(), u(r);
				break;
			default: break;
		}
	};
	return /* @__PURE__ */ r("div", {
		role: "tablist",
		"aria-label": a,
		className: t("brut-tabs", s),
		children: e.map((e, a) => {
			let s = e.value === n;
			return /* @__PURE__ */ r("button", {
				ref: (e) => {
					c.current[a] = e;
				},
				type: "button",
				role: "tab",
				"aria-selected": s,
				"aria-controls": o,
				tabIndex: s ? 0 : -1,
				className: t("brut-tab", s && "brut-tab-active"),
				onClick: () => i(e.value),
				onKeyDown: (e) => d(e, a),
				children: e.label
			}, String(e.value));
		})
	});
}
//#endregion
//#region src/MultiSelectChips.tsx
function U({ options: e, selected: n, onToggle: r, ariaLabel: a, reset: o, className: s }) {
	return /* @__PURE__ */ i("div", {
		role: "group",
		"aria-label": a,
		className: t("brut-chip-group", s),
		children: [o, e.map((e) => {
			let a = n.has(e.value);
			return /* @__PURE__ */ i("button", {
				type: "button",
				"aria-pressed": a,
				className: t("brut-chip", a && "brut-chip-active", e.className),
				onClick: () => r(e.value),
				children: [e.leading, e.label]
			}, String(e.value));
		})]
	});
}
//#endregion
//#region src/MetricRow.tsx
function W({ leading: e, leadingClassName: n, value: a, valueClassName: o, className: s, ...c }) {
	return /* @__PURE__ */ i("div", {
		className: t("brut-metric-row", s),
		...c,
		children: [/* @__PURE__ */ r("span", {
			className: t("brut-metric-row-leading", n),
			children: e
		}), /* @__PURE__ */ r("span", {
			className: t("brut-metric-row-value", o),
			children: a
		})]
	});
}
//#endregion
export { N as Alert, v as Badge, f as Button, m as Card, T as ConfirmDialog, w as Dialog, L as EmptyState, P as FormField, h as Input, _ as Kbd, y as Menu, b as MenuItem, W as MetricRow, U as MultiSelectChips, I as Panel, R as Ping, F as SegmentedControl, g as Select, V as StatRow, H as Tabs, A as ToastProvider, D as useToast };

//# sourceMappingURL=index.js.map